import { DeepPartial } from "react-hook-form";
import { SalesPartFormValues } from "src/components/views/erp/sales/masterData/salesParts/SalesPartFormContent.tsx";
import { getObjectAccountingFormDefaultValues } from "src/components/views/erp/common/accounting/ObjectAccountingForm.utils.ts";
import { PartView } from "src/api/generated/erp/db/types/tables/partView.ts";
import { getDefaultVatCode } from "src/components/views/erp/sales/salesUtils.ts";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode.ts";
import { AccountingDimension } from "src/api/generated/erp/db/types/tables/accountingDimension.ts";
import { ConfigurationDefaultPricingMethod } from "src/api/generated/erp/db/types/enums/configurationDefaultPricingMethod.ts";

interface PartInput
	extends Partial<
		Pick<
			PartView,
			| "partNo"
			| "partDescription_1"
			| "partDescription_2"
			| "partUnitId"
			| "siteId"
			| "acquisitionMethod"
			| "partId"
		>
	> {}

export function getSalesPartFormDefaultValues({
	part,
	defaultSiteId,
	vatCodeOptions,
	accountingDimensions,
	configurationDefaultPricingMethod = "BOM",
}: {
	part: PartInput | null | undefined;
	defaultSiteId: number;
	vatCodeOptions: VatCode[];
	accountingDimensions: AccountingDimension[];
	configurationDefaultPricingMethod?: ConfigurationDefaultPricingMethod;
}): DeepPartial<SalesPartFormValues> {
	const defaultSalesPartType =
		part == null ? undefined
		: part.acquisitionMethod === "SPLIT_BOM" ? "PACKAGE_"
		: "WAREHOUSE";

	return {
		partId: part?.partId,
		salesPartNo: part?.partNo,
		salesPartDescription: part ? `${part.partDescription_1 ?? ""} ${part.partDescription_2 ?? ""}` : "",
		salesPriceUnitId: part?.partUnitId,
		salesUnitId: part?.partUnitId,
		priceFactor: 1,
		salesFactor: 1,
		isDefault: true,
		active: true,
		canBeUsedOnCustomerOrderLine: true,
		canBeUsedOnCustomerOfferLine: true,
		siteId: part?.siteId ?? defaultSiteId,
		vatCodeId: getDefaultVatCode(vatCodeOptions).vatCodeId,
		salesPartType: defaultSalesPartType,
		importCodes: [],
		isAdjustment: false,
		hasTemplateConfiguration: false,
		automaticDelivery: false,
		configurationDefaultPricingMethod,
		...getObjectAccountingFormDefaultValues(
			accountingDimensions.map((dimension) => ({
				dimension,
				accountingCode: null,
			})),
		),
	};
}
